<template>
  <page-wrapper :title="'รายละเอียดการนัดหมาย'" :no-pad-btm="true">
    <!-- Appointment dialog -->
    <div v-if="isShowAppointmentMenu" class="dialog-bg">
      <div class="dialog-box">
        <div class="header">
          <p>{{ "นัดวันให้บริการ" }}</p>
          <div class="close-btn" @click="hideAppointmentMenu">
            <i class="fa fa-times"></i>
          </div>
        </div>
        <div class="content">
          <p>{{ "วันที่" }}</p>
          <el-date-picker
            id="appointment_date"
            v-model="appointmentForm.date"
            :placeholder="'ระบุวันที่'"
            class="item"
            name="appointment_date"
            type="date"
            format="dd MMMM yyyy"
          />
          <p class="mt-2">{{ "เวลานัด" }}</p>
          <el-time-picker
            id="appointment_start_time"
            v-model="appointmentForm.startTime"
            :placeholder="'00:00'"
            class="item"
            name="appointment_start_time"
            format="HH:mm"
            type="time"
          ></el-time-picker>
          <p class="mt-2">{{ "ถึง" }}</p>
          <el-time-picker
            id="appointment_end_time"
            v-model="appointmentForm.endTime"
            :placeholder="'00:00'"
            class="item"
            name="appointment_end_time"
            format="HH:mm"
            type="time"
          ></el-time-picker>
          <p class="mt-2">
            {{
              isRequireAppointmentNote
                ? "เหตุผลการเปลี่ยนวันนัด"
                : "บันทึกการนัดบริการ"
            }}
          </p>
          <el-input
            v-model="appointmentForm.note"
            :placeholder="
              isRequireAppointmentNote
                ? 'ระบุเหตุผลการเปลี่ยนวันนัด'
                : 'ระบุข้อความ'
            "
            type="textarea"
            rows="3"
          ></el-input>
          <div class="button-wrapper">
            <button class="me-1 button cancel" @click="hideAppointmentMenu">
              {{ "ยกเลิก" }}
            </button>
            <button class="ms-1 button submit" @click="confirmAppointment">
              {{ "บันทึก" }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Appointment fulfill dialog -->
    <div v-if="isShowFulfillAppointmentMenu" class="dialog-bg">
      <div class="dialog-box">
        <div class="header">
          <p>{{ "บันทึกปิดงาน" }}</p>
          <div class="close-btn" @click="hideFulfillAppointmentMenu">
            <i class="fa fa-times"></i>
          </div>
        </div>
        <div class="content">
          <p>{{ "วันที่" }}</p>
          <el-date-picker
            id="appointment_date"
            v-model="fulfillForm.date"
            :placeholder="'ระบุวันที่'"
            class="item"
            name="appointment_date"
            type="date"
            format="dd MMMM yyyy"
          />
          <p class="mt-2">{{ "เวลา" }}</p>
          <el-time-picker
            id="fulfilled_appointment_start_time"
            v-model="fulfillForm.time"
            :placeholder="'00:00'"
            class="item"
            name="fulfilled_appointment_start_time"
            format="HH:mm"
            type="time"
          ></el-time-picker>
          <p class="mt-2">
            {{ "รายละเอียดการให้บริการ" }}
          </p>
          <el-input
            v-model="fulfillForm.message"
            type="textarea"
            rows="3"
            placeholder="ระบุรายละเอียดการให้บริการ"
          ></el-input>
          <p class="mt-2">
            {{ "รูปปิดงาน" }}
          </p>
          <p class="remark">{{ "* จำกัดขนาดรูปไม่เกิน 10 MB" }}</p>
          <p class="remark">
            {{ "* ไฟล์ที่รองรับ jpg, jpeg, png, heic, heif" }}
          </p>
          <div class="attach-image-wrapper mt-2">
            <button class="attach-button" @click="selectFulfillImage">
              <i class="fas fa-plus fa-xs" style="color: #444444"></i
              >{{ "เพิ่มรูป" }}
            </button>
            <input
              ref="fulfillImageRef"
              type="file"
              accept="image/jpg, image/jpeg, image/png, image/heic, image/heif"
              hidden
              multiple
              @click="resetFulfillImageRef"
              @change="changeFulfillImages($event.target.files)"
              @cancel="attachingFulfillImage = false"
            />
          </div>
          <div
            v-if="isAttachedFulfillImage"
            class="mt-2 attached-image-wrapper"
          >
            <div
              v-for="image in fulfillForm.images"
              :key="image.key"
              class="image-wrapper"
            >
              <img v-if="image.url" :src="image.url" />
              <div v-else class="attach-image-background">
                <div class="spinner"></div>
              </div>
              <p>{{ image.name }}</p>
              <div v-if="image.url" class="remove-image">
                <i
                  class="fa fa-times"
                  @click="removeFulfillImage(image.key)"
                ></i>
              </div>
            </div>
          </div>
          <div class="button-wrapper">
            <button class="me-1 button cancel" @click="cancelAttachImage">
              {{ "ยกเลิก" }}
            </button>
            <button class="ms-1 button submit" @click="fulfillAppointment">
              {{ "ปิดงาน" }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Page content -->
    <div v-if="isDesktop" class="content-wrapper">
      <div class="left">
        <user-info v-if="appointment" :appointment="appointment" />
        <fulfilled v-if="isFulfilled" :appointment="appointment" />
        <registration-form
          v-if="registrationForm"
          :registration-form="registrationForm"
        />
      </div>
      <div class="right">
        <appointment
          v-if="isShowAppointment"
          :appointment="appointment"
          :service="service"
          :is-show-view-all-appointment-btn="isShowViewAllAppointmentBtn"
          @showAppointment="showAppointmentMenu"
          @showFulfillAppointment="showFulfillAppointmentMenu"
          @viewAllAppointment="viewAllAppointment"
        />
        <log-history
          v-if="isShowLogHistory"
          :current-appointment-notices="currentAppointmentNotices"
          :appointment-canceled="appointmentCanceled"
        />
      </div>
    </div>
    <div v-else class="content-wrapper">
      <appointment
        v-if="isShowAppointment"
        :appointment="appointment"
        :service="service"
        :is-show-view-all-appointment-btn="isShowViewAllAppointmentBtn"
        @showAppointment="showAppointmentMenu"
        @showFulfillAppointment="showFulfillAppointmentMenu"
        @viewAllAppointment="viewAllAppointment"
      />
      <user-info v-if="appointment" :appointment="appointment" />
      <fulfilled v-if="isFulfilled" :appointment="appointment" />
      <registration-form
        v-if="registrationForm"
        :registration-form="registrationForm"
      />
      <log-history
        v-if="isShowLogHistory"
        :current-appointment-notices="currentAppointmentNotices"
        :appointment-canceled="appointmentCanceled"
      />
    </div>
  </page-wrapper>
</template>

<script>
import { DatePicker, TimePicker, Input } from "element-ui"
import { baanRueJaiClient } from "@/dependencies"
import { DateTime } from "luxon"
import { UPLOAD } from "@/config/constant"
import { uploadPublicImage } from "@/god"
import { toLocaleTH } from "@/lib/dateTime"
import { resize, resizeHeicOrHeif } from "@/lib/resizeImage"
import { isEmpty } from "ramda"
import { mSize } from "../StaticVariable"
import { navigationMenu } from "../../lib/mapper"
import AppointmentLogHistory from "../components/AppointmentLogHistory"
import JobDetailAppointment from "../components/JobDetailAppointment"
import JobDetailFulfilled from "../components/JobDetailFulfilled"
import JobDetailRegistrationForm from "../components/JobDetailRegistrationForm"
import JobDetailUserInfo from "../components/JobDetailUserInfo"
import PageWrapper from "../components/SupplierPageWrapper"

export default {
  components: {
    PageWrapper,
    "user-info": JobDetailUserInfo,
    "registration-form": JobDetailRegistrationForm,
    fulfilled: JobDetailFulfilled,
    appointment: JobDetailAppointment,
    "log-history": AppointmentLogHistory,
    "el-date-picker": DatePicker,
    "el-time-picker": TimePicker,
    "el-input": Input,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      appointment: null,
      subscriber: null,
      service: null,
      registrationForm: null,
      noticeId: null,
      currentAppointmentNotices: null,
      appointmentCanceled: null,
      showAppointment: false,
      showFulfillAppointment: false,
      attachingFulfillImage: false,
      updatedAppointment: false,
      appointmentForm: {
        date: null,
        startTime: null,
        endTime: null,
        note: null,
      },
      fulfillForm: {
        date: null,
        time: null,
        message: null,
        images: [],
      },
    }
  },
  computed: {
    isDesktop() {
      return this.windowWidth >= mSize
    },
    appointmentId() {
      return this.$route.params.appointmentId
    },
    isUpdatedAppointment() {
      return this.updatedAppointment
    },
    isShowAppointmentMenu() {
      return this.showAppointment
    },
    isShowAppointment() {
      return this.appointment && this.service
    },
    isShowLogHistory() {
      return (
        (this.currentAppointmentNotices &&
          this.currentAppointmentNotices.length > 0) ||
        (this.appointmentCanceled && this.appointmentCanceled.length > 0)
      )
    },
    isRequireAppointmentNote() {
      const { date, startTime, endTime } = this.appointmentForm

      if (!date || !startTime) {
        return true
      }

      const defaultStartDate = toLocaleTH(this.appointment.dateTime).toISO()
      const defaultEndDate = this.appointment.dateTimeEnd
        ? toLocaleTH(this.appointment.dateTimeEnd).toISO()
        : null

      const selectedStartDate = DateTime.fromJSDate(date)
        .set({
          hour: startTime.getHours(),
          minute: startTime.getMinutes(),
        })
        .toISO()
      const selectedEndDate = endTime
        ? DateTime.fromJSDate(date)
            .set({
              hour: endTime.getHours(),
              minute: endTime.getMinutes(),
            })
            .toISO()
        : null

      const isDateRangeModified =
        selectedStartDate !== defaultStartDate ||
        selectedEndDate !== defaultEndDate

      return this.noticeId && isDateRangeModified
    },
    isShowFulfillAppointmentMenu() {
      return this.showFulfillAppointment
    },
    isAttachingFulfillImage() {
      return this.attachingFulfillImage
    },
    isFulfilled() {
      return this.appointment && this.appointment.providerFulfilledAt
    },
    isShowViewAllAppointmentBtn() {
      return this.appointment && this.subscriber
    },
    isAttachedFulfillImage() {
      return this.fulfillForm.images.length > 0
    },
  },
  watch: {
    "$route.query": async function routeQueryWatcher() {
      await this.setupData()
    },
    "appointmentForm.date": function appointmentFormDateWatcher(value) {
      if (!value) {
        this.appointmentForm.date = null
        this.appointmentForm.startTime = null
        this.appointmentForm.endTime = null
        this.appointmentForm.note = null
      }
    },
  },
  created() {
    this.setup()
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize)
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth
    },
    setup() {
      this.setupData()
    },
    async setupData() {
      await this.setupAppointmentDetail()
    },
    async setupAppointmentDetail() {
      try {
        const { appointment } = await this.fetchAppointmentDetail(
          this.appointmentId,
        )
        this.appointment = appointment

        let { idForRedirectPage } = appointment
        this.appointmentForm.date = appointment.dateTime.toJSDate()
        this.appointmentForm.startTime = appointment.dateTime.toJSDate()
        this.appointmentForm.endTime = appointment.dateTimeEnd
          ? this.appointment.dateTimeEnd.toJSDate()
          : null

        if (this.isUpdatedAppointment) {
          this.updatedAppointment = false

          if (!idForRedirectPage || idForRedirectPage === appointment.id) {
            idForRedirectPage = appointment.id
          }

          await this.updateAppointmentStatus(idForRedirectPage, {
            status: "CONFIRMED",
          })

          this.$router.push({
            name: this.$route.name,
            params: {
              appointmentId: idForRedirectPage,
              navigationMenu: navigationMenu.PENDING,
            },
          })

          window.location.reload()
        }

        try {
          const { registrationForm, subscriber } =
            await this.fetchSubscriberDetail(
              this.appointment.subscriptionMemberId,
            )

          this.registrationForm = registrationForm
          this.subscriber = subscriber
          this.service = subscriber.services.find(
            (service) => service.id.toString() === appointment.service.id,
          )
        } catch (error) {
          // eslint-disable-next-line no-console
          console.warn(error)
        }

        try {
          const {
            current_appointment_notices: currentAppointmentNotices,
            appointment_canceled: appointmentCanceled,
          } = await this.fetchAppointmentNotices(this.appointmentId)

          this.currentAppointmentNotices = currentAppointmentNotices
          this.appointmentCanceled = appointmentCanceled

          const matchingNotice = currentAppointmentNotices.find(
            (item) => item.status === this.appointment.status,
          )
          this.noticeId = matchingNotice ? matchingNotice.id : null
        } catch (error) {
          // eslint-disable-next-line no-console
          console.warn(error)
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err)
      }
    },
    async fetchAppointmentDetail(appointmentId) {
      return baanRueJaiClient.others.supplier.getProviderAppointmentDetail(
        appointmentId,
      )
    },
    async fetchAppointmentNotices(appointmentId) {
      return baanRueJaiClient.others.supplier.getAppointmentNotices(
        appointmentId,
      )
    },
    async fetchSubscriberDetail(subscriptionMemberId) {
      return baanRueJaiClient.others.supplier.getSubscriberDetail(
        subscriptionMemberId,
      )
    },
    async updateAppointment(appointmentId, params) {
      return baanRueJaiClient.others.supplier.updateAppointment(
        appointmentId,
        params,
      )
    },
    async updateAppointmentStatus(appointmentId, params) {
      return baanRueJaiClient.others.supplier.updateAppointmentStatus(
        appointmentId,
        params,
      )
    },
    async createNote(params) {
      return baanRueJaiClient.others.supplier.createNote(params)
    },
    showAppointmentMenu() {
      this.showAppointment = true
    },
    hideAppointmentMenu() {
      this.showAppointment = false
    },
    showFulfillAppointmentMenu() {
      this.showFulfillAppointment = true
    },
    hideFulfillAppointmentMenu() {
      this.showFulfillAppointment = false
    },
    viewAllAppointment() {
      this.$router.push({
        name: "SupplierAppointmentList",
        params: { appointmentId: this.appointmentId },
      })
    },
    async confirmAppointment() {
      const { date, startTime, endTime, note } = this.appointmentForm

      if (!date || !startTime) {
        this.$message.error(`กรุณาเลือกวันที่ และเวลานัด`)
        return
      }

      const startDateFormat = DateTime.fromJSDate(date).set({
        hour: startTime.getHours(),
        minute: startTime.getMinutes(),
      })
      const endDateFormat = endTime
        ? DateTime.fromJSDate(date).set({
            hour: endTime.getHours(),
            minute: endTime.getMinutes(),
          })
        : undefined

      if (endDateFormat && startDateFormat > endDateFormat) {
        this.$message.error(`เวลานัดไม่ถูกต้อง`)
        return
      }

      if (this.isRequireAppointmentNote && !note) {
        this.$message.error(`กรุณาระบุเหตุผลการเปลี่ยนวันนัด`)
        return
      }

      this.hideAppointmentMenu()

      try {
        if (note) {
          const createNoteParams = {
            appointment_notice_id: this.noticeId,
            note,
          }
          await this.createNote(createNoteParams)
        }

        if (this.isRequireAppointmentNote) {
          const updateAppointmentParams = {
            date: startDateFormat,
            date_end: endDateFormat,
          }
          await this.updateAppointment(
            this.appointment.id,
            updateAppointmentParams,
          )
        }

        this.updatedAppointment = true

        this.setupData()
      } catch (error) {
        this.$message.error("ไม่สามารถนัดหมายได้ กรุณากดนัดหมายอีกครั้ง")
        // eslint-disable-next-line no-console
        console.error(error)
      }
    },
    resetFulfillImageRef() {
      this.$refs.fulfillImageRef.value = ""
    },
    selectFulfillImage() {
      if (this.isAttachingFulfillImage) {
        this.$message.error("กำลังเพิ่มรูป กรุณารอสักครู่")
        return
      }

      this.$refs.fulfillImageRef.click()
      this.attachingFulfillImage = true
    },
    async changeFulfillImages(files) {
      const selectFiles = Array.from(files)
      const currentImageCount = this.fulfillForm.images.length

      if (await this.canAttachImages(selectFiles, currentImageCount)) {
        try {
          await Promise.all(
            selectFiles.map((selectFile, fileIndex) => {
              const index = currentImageCount + fileIndex
              const imageKey = `image_${index}`
              const imageData = {
                key: imageKey,
                file: selectFile,
                name: selectFile.name,
                url: null,
              }

              return this.addImageToFulfillForm(imageData, index)
            }),
          )

          this.attachingFulfillImage = false
        } catch (error) {
          this.$message.error(
            "เพิ่มรูปไม่สำเร็จ กรุณาลองใหม่อีกครั้ง หรือเลือกรูปอื่น",
          )
          this.attachingFulfillImage = false

          // eslint-disable-next-line no-console
          console.error(error)
        }
      }
    },
    async canAttachImages(selectFiles, currentImageCount) {
      const maxImageCount = 5
      const maxImageSizeMB = UPLOAD.MAX_FILE_SIZE_10MB

      if (selectFiles.length + currentImageCount > maxImageCount) {
        this.$message.error(`สามารถใส่รูปได้ไม่เกิน ${maxImageCount} รูป`)
        this.attachingFulfillImage = false

        return false
      }

      const isImageLarger = selectFiles.some(
        (file) => file.size / 1024 / 1024 > maxImageSizeMB,
      )

      if (isImageLarger) {
        this.$message.error(`จำกัดขนาดรูปไม่เกิน ${maxImageSizeMB} MB`)
        this.attachingFulfillImage = false

        return false
      }

      return true
    },
    async addImageToFulfillForm(imageData, index) {
      this.fulfillForm.images.push(imageData)

      const isHeicOrHeifFormat = ["image/heic", "image/heif"].includes(
        imageData.file.type,
      )

      const resizedFile = isHeicOrHeifFormat
        ? await resizeHeicOrHeif(imageData.file)
        : await resize(imageData.file)

      const indexToUpdate = this.fulfillForm.images.findIndex(
        (img) => img.key === `image_${index}`,
      )

      if (indexToUpdate !== -1) {
        this.fulfillForm.images = this.fulfillForm.images.map((img) =>
          img.key === `image_${index}`
            ? {
                ...img,
                file: resizedFile,
                url: URL.createObjectURL(resizedFile),
              }
            : img,
        )
      }
    },
    removeFulfillImage(key) {
      if (this.isAttachingFulfillImage) {
        this.$message.error("กำลังเพิ่มรูป กรุณารอสักครู่")
        return
      }

      const removeImages = this.fulfillForm.images
        .filter((imageItem) => imageItem.key !== key)
        .map((imageItem, imageIndex) => ({
          ...imageItem,
          key: `image_${imageIndex}`,
        }))

      this.fulfillForm.images = removeImages
    },
    cancelAttachImage() {
      this.hideFulfillAppointmentMenu()

      this.fulfillForm.time = null
      this.fulfillForm.message = null
      this.attachingFulfillImage = false
    },
    async fulfillAppointment() {
      if (this.isAttachingFulfillImage) {
        this.$message.error("กำลังเพิ่มรูป กรุณารอสักครู่")
        return
      }

      const { date, time, message, images } = this.fulfillForm

      if (!date || !time) {
        this.$message.error("กรุณาเลือกวันที่ และเวลาปิดงาน")
        return
      }

      if (isEmpty(images)) {
        this.$message.error("กรุณาเพิ่มรูปอย่างน้อย 1 รูป")
        return
      }

      const fulfillDateTimeFormat = DateTime.fromJSDate(date).set({
        hour: time.getHours(),
        minute: time.getMinutes(),
      })
      const currentDate = DateTime.now().set({
        second: 0,
        millisecond: 0,
      })
      const isDateGreaterThanNow = fulfillDateTimeFormat > currentDate

      if (isDateGreaterThanNow) {
        this.$message.error("ไม่สามารถปิดงานล่วงหน้าได้")
        return
      }

      this.hideFulfillAppointmentMenu()

      try {
        const uploadedUrls =
          images.length > 0
            ? await Promise.all(
                images.map((image) =>
                  uploadPublicImage(image.file, "", "fulfill"),
                ),
              )
            : null

        const params = {
          status: "PROVIDER_FULFILLED",
          serviceId: this.appointment.service.id,
          provider_fulfilled_at: fulfillDateTimeFormat,
          provider_fulfilled_detail: message || undefined,
          provider_fulfilled_ImageUrls: uploadedUrls
            ? [uploadedUrls]
            : undefined,
        }

        await this.updateAppointmentStatus(this.appointmentId, params)

        this.$router.replace({
          name: "SupplierJobList",
          params: {
            appointmentId: this.appointment.idForRedirectPage,
            navigationMenu: navigationMenu.FINISHED,
          },
        })
      } catch (error) {
        this.$message.error("ปิดงานไม่สำเร็จ กรุณากดปิดงานอีกครั้ง")
        // eslint-disable-next-line no-console
        console.error(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.dialog-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;

  > .dialog-box {
    background-color: $white;
    border-radius: 8px;
    width: 320px;
    max-height: 100%;
    overflow-y: auto;

    > .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: $supplier-primary-color;

      p {
        padding-inline: 16px;
        padding-block: 8px;
        font-size: $font-18;
        font-weight: bold;
        color: $white;
      }

      > .close-btn {
        padding-inline: 16px;
        padding-block: 8px;
        color: $white;
        cursor: pointer;

        &:hover:not(:disabled) {
          opacity: 0.7;
        }
      }
    }

    > .content {
      display: flex;
      flex-direction: column;
      padding: 16px;

      p {
        font-size: $font-16;
        color: $black;
      }

      .remark {
        font-size: 14px;
        color: #606060;
        line-height: 1.5;
      }

      > .item {
        width: 100%;
      }

      > .el-date-editor.el-input,
      > .el-date-editor.el-input__inner {
        width: 100%;
      }

      > .button-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 24px;

        > .button {
          flex: 1;
          padding-inline: 16px;
          height: 44px;
          font-weight: bold;
          font-size: $font-16;
          border-radius: 8px;
          border: none;
        }

        > .cancel {
          color: $black;
          background: transparent;
          border: 1px solid $color-light-gray-1;
          margin-right: 4px;

          &:hover:not(:disabled) {
            background: $color-light-gray-1-hover;
          }
        }

        > .submit {
          color: $white;
          background: $supplier-primary-color;
          margin-left: 4px;

          &:hover:not(:disabled) {
            background: $supplier-primary-light-color;
          }
        }
      }

      > .attach-image-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;

        > .attach-button {
          padding-inline: 16px;
          height: 44px;
          font-weight: normal;
          font-size: $font-16;
          border-radius: 8px;
          color: $black;
          background: transparent;
          border: 1px solid $color-light-gray-1;
          margin-right: 4px;
          display: flex;
          align-items: center;

          &:hover:not(:disabled) {
            background: $color-light-gray-1-hover;
          }

          i {
            margin-right: 8px;
          }
        }
      }

      > .attached-image-wrapper {
        display: flex;
        flex-direction: column;

        > .image-wrapper {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-top: 8px;

          > .attach-image-background {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 40px;
            height: 40px;
            margin-right: 8px;
            background: #e6e6e6;

            > .spinner {
              border: 0.2em solid rgba(0, 0, 0, 0.1);
              border-top-color: #767676;
              border-radius: 50%;
              width: 1em;
              height: 1em;
              animation: spin 1s ease-in-out infinite;
            }

            @keyframes spin {
              to {
                transform: rotate(360deg);
              }
            }
          }
        }

        img {
          width: 40px;
          height: 40px;
          margin-right: 8px;
          object-fit: cover;
        }

        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-right: 12px;
          flex: 1;
        }

        i {
          cursor: pointer;
        }
      }

      .el-textarea,
      .el-input {
        font-size: $font-16;
      }
    }
  }
}

.content-wrapper {
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: calc(28% - 12px) calc(72% - 12px);
  grid-gap: 24px;
  padding: 24px;

  > .left {
    display: flex;
    flex-direction: column;
    grid-gap: 24px;
  }

  > .right {
    display: flex;
    flex-direction: column;
    grid-gap: 24px;
  }
}

@media (max-width: ($m-size - 1)) {
  .content-wrapper {
    display: flex;
    flex-direction: column;
    grid-gap: 16px;
    padding: 16px;
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .content-wrapper {
    grid-template-columns: calc(38% - 8px) calc(62% - 8px);
    grid-gap: 16px;
    padding: 16px;

    > .left {
      grid-gap: 16px;
    }

    > .right {
      grid-gap: 16px;
    }
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .content-wrapper {
    grid-template-columns: calc(28% - 6px) calc(72% - 6px);
    grid-gap: 12px;
    padding: 12px;

    > .left {
      grid-gap: 12px;
    }

    > .right {
      grid-gap: 12px;
    }
  }
}
</style>
